import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","z-index":"9999999"},
  class: "BGGradient D-Flex W-100 H-100"
}
const _hoisted_2 = {
  class: "M-Auto Color3 F3_5em O-50 D-Flex FlexColumn",
  style: {"justify-content":"center","align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Under Maintenance", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "W-100",
  style: {"height":"5em"}
}, null, -1)
const _hoisted_5 = {
  style: {"margin-top":"2em","left":"0","flex-direction":"column"},
  class: "W-100 D-Flex P-Abs"
}
const _hoisted_6 = { class: "M-Auto" }
const _hoisted_7 = {
  class: "M-Auto F1_5em",
  style: {"margin-top":"3em"}
}
const _hoisted_8 = {
  class: "CookiesSignInCopyrights O-5",
  style: {"bottom":"5em","letter-spacing":"0.3em"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "color3",
  style: {"font-size":"0.8em","margin":"auto 0em"}
}, " powered by: ", -1)
const _hoisted_10 = {
  class: "D-Flex",
  href: "https://cookiesbis.com/",
  target: "_blank"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "W-100 H-100 D-Flex"
}
const _hoisted_13 = { class: "M-Auto" }
const _hoisted_14 = {
  key: 3,
  class: "NewerVersion HoverGlow"
}
const _hoisted_15 = {
  class: "F-Bold",
  style: {"color":"rgb(23,23,23) !important"}
}
const _hoisted_16 = {
  class: "V-Auto F_75em O-50",
  style: {"color":"rgb(23,23,23) !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNav = _resolveComponent("CookiesNav")!
  const _component_CookiesToolTip = _resolveComponent("CookiesToolTip")!
  const _component_CookiesNotification = _resolveComponent("CookiesNotification")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_CookiesBranchSelector = _resolveComponent("CookiesBranchSelector")!
  const _component_CookiesSignIn = _resolveComponent("CookiesSignIn")!
  const _component_CookiesDomPrint = _resolveComponent("CookiesDomPrint")!

  return (_ctx.Maintenance && !_ctx.Access('SuperAdmin'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_CookiesIcon, {
            style: {"width":"5em","height":"5em"},
            Color: ({ ColorA: 'black' } as IconColor),
            class: "Shadow3 Rotation360",
            ID: ('Settings' as IconsIDs)
          }, null, 8, ["Color", "ID"]),
          _hoisted_3
        ])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.Configed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "CookiesStyler",
              onMousemove: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ToolTipSence()))
            }, [
              (_ctx.$store.state.Accessable && (_ctx.$store.state.BranchManagment.BranchesMode ? _ctx.$store.state.BranchManagment.CurrentBranch : true))
                ? (_openBlock(), _createBlock(_component_CookiesNav, {
                    key: 0,
                    Items: _ctx.NavItems
                  }, null, 8, ["Items"]))
                : _createCommentVNode("", true),
              _createVNode(_component_CookiesToolTip, { class: "NOPRINT" }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.CookiesNotifications.Messages, (message) => {
                return (_openBlock(), _createBlock(_component_CookiesNotification, {
                  key: message,
                  Message: message
                }, null, 8, ["Message"]))
              }), 128)),
              _createElementVNode("div", {
                dir: "ltr",
                id: "MainAppContainer",
                class: _normalizeClass(["CookiesApp COOKIESAPPVUE", [_ctx.$store.state.Printing !== '' && 'PrintingHider', _ctx.$store.state.CookiesConfig.background && _ctx.$store.state.CookiesConfig.background]])
              }, [
                (_ctx.$store.state.Accessable && (_ctx.$store.state.BranchManagment.BranchesMode ? _ctx.$store.state.BranchManagment.CurrentBranch : true))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["CookiesMainContainer", _ctx.$store.state.Printing !== '' && 'PrintingHider']),
                      style: _normalizeStyle(!_ctx.Access('Main_Navigation') ? 'margin-left: 0em;' : '')
                    }, [
                      _createVNode(_component_router_view),
                      _hoisted_4
                    ], 6))
                  : _createCommentVNode("", true),
                (!_ctx.$store.state.Accessable)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", {
                            style: _normalizeStyle([{"width":"22em","height":"22em","max-width":"100%","background-size":"contain","background-repeat":"no-repeat","background-position":"center"}, 'background-image: url(' + _ctx.$store.getters.DynamicConfig.Logo + ');'])
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_CookiesLoading)
                        ])
                      ]),
                      (_ctx.$store.state.BranchManagment.BranchesMode)
                        ? (_openBlock(), _createBlock(_component_CookiesBranchSelector, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_ctx.$store.state.AutoSignIn)
                        ? (_openBlock(), _createBlock(_component_CookiesSignIn, {
                            key: 1,
                            onSignedIn: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CookiesAuthorization())),
                            class: "noprint"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$store.state.CookiesVersion), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$store.state.CookiesConfig.NoCopyRights ? 'D-None' : '', "CookiesSignInCopyrights Shadow3"])
                      }, [
                        _hoisted_9,
                        _createElementVNode("a", _hoisted_10, [
                          _createElementVNode("img", {
                            style: {"height":"70%","margin":"auto 1em"},
                            src: _ctx.$store.getters.CurrentTheme === 'light' ? require('@/assets/defaults/DarkCookies.svg') : require('@/assets/defaults/MilkCookies.svg'),
                            alt: ""
                          }, null, 8, _hoisted_11)
                        ])
                      ], 2)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              (_openBlock(), _createBlock(_resolveDynamicComponent('CookiesDialog')))
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_CookiesLoading)
              ])
            ])),
        (_ctx.$store.state.Printing !== '')
          ? (_openBlock(), _createBlock(_component_CookiesDomPrint, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.$store.state.CookiesVueServerVersion && _ctx.$store.state.CookiesVueServerVersion !== _ctx.$store.state.CookiesVersion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "BGGreen Shadow3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.RefreshPage()))
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR1_5em",
                  ID: ('Recover' as IconsIDs),
                  Color: ({ ColorA: 'rgba(0,0,0,0.85)' } as IconColor)
                }, null, 8, ["ID", "Color"]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.Translate('New Update')), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$store.state.CookiesVueServerVersion), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
}